"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumToJSON = exports.PremiumFromJSONTyped = exports.PremiumFromJSON = exports.instanceOfPremium = void 0;
var runtime_1 = require("../runtime");
var CampaignAdProduct_1 = require("./CampaignAdProduct");
/**
 * Check if a given object implements the Premium interface.
 */
function instanceOfPremium(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPremium = instanceOfPremium;
function PremiumFromJSON(json) {
    return PremiumFromJSONTyped(json, false);
}
exports.PremiumFromJSON = PremiumFromJSON;
function PremiumFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'adProduct': !(0, runtime_1.exists)(json, 'ad_product') ? undefined : (0, CampaignAdProduct_1.CampaignAdProductFromJSON)(json['ad_product']),
        'rate': !(0, runtime_1.exists)(json, 'rate') ? undefined : json['rate'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'isActive': !(0, runtime_1.exists)(json, 'isActive') ? undefined : json['isActive'],
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
    };
}
exports.PremiumFromJSONTyped = PremiumFromJSONTyped;
function PremiumToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'ad_product': (0, CampaignAdProduct_1.CampaignAdProductToJSON)(value.adProduct),
        'rate': value.rate,
        'type': value.type,
        'isActive': value.isActive,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
exports.PremiumToJSON = PremiumToJSON;
